export const templateConstants = {
  MAX_TEMPLATE_NAME_COPIES: 100 // Max number of iterations a template name will have an index appended if a duplicate exists
};
export const TEMPLATE_TABLE_STATE_NAME = "template_table";
